<script setup>
  
</script>

<template>
    <div class="attribution">
        Challenge by <a href="https://www.frontendmentor.io?ref=challenge">Frontend Mentor</a>. 
        Coded by <a href="https://github.com/KarenNR" target="_blank">Karen Garza</a>.
    </div>
</template>

<style scoped>
    .attribution { font-size: 11px; text-align: center; }
    .attribution a { color: hsl(228, 45%, 44%); }
</style>
